import {submitYiiForm} from "../helpers/yii";

const LocalStorageKey = 'trCerebroV2';

const getViews = () => window.localStorage.getItem(LocalStorageKey);
const setViews = views => window.localStorage.setItem(LocalStorageKey, JSON.stringify(views));
const clearViews = () => window.localStorage.removeItem(LocalStorageKey);

export default {
    bind() {
        const tracker = {
            views: [],
        };

        // Retrieve the object from storage if it's a video page
        if (typeof window.variables.tracking.photos !== "undefined") {
            const views = getViews();
            if (views) {
                submitYiiForm(window.variables.tracking.photos, {views});
                console.log(JSON.parse(views));
                clearViews();
            }
        }

        if ("IntersectionObserver" in window ) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if ( entry.intersectionRatio > 0) {
                        const data = entry.target.dataset.tracker.split(':');

                        // Logic here
                        tracker.views.push({
                            photo_id: +data[0],
                            movie_id: +data[1],
                        });

                        setViews(tracker.views);
                        // Stop observer
                        observer.unobserve(entry.target);
                    }

                });
            });

            // Loop to catch all changes
            setInterval(() => {
                Array.prototype.slice.call(document.querySelectorAll("[data-cerebro]")).forEach((i) => {
                    observer.observe(i);
                    i.dataset.tracker = i.dataset.cerebro;
                    delete i.dataset.cerebro;
                });
            }, 150 );
        }
    }
}
